<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',
};
</script>
<style>
.logo {
  height: 6em;

  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
html, body {
  overflow: hidden;
  height: 100%;
}
</style>
